<script>
import FacilitySelect from "@/views/orders/components/FacilitySelect.vue";
import { OrdersMixin } from "@/views/orders/orders.mixin";
import OmniDialog from "@/components/OmniDialog.vue";
import { customAlphabet } from "nanoid";
import { OrderStopStatus, OrderStopTimeType, OrderStopType } from "@/data/order.js";

export default {
  name: "AddReloadStopDialog",
  components: { OmniDialog, FacilitySelect },
  mixins: [OrdersMixin],
  props: {
    modelValue: Boolean,
    tripStops: Array,
    position: Number,
  },
  emits: ["update:modelValue", "add"],
  data() {
    return {
      facilityId: null,
      note: "",
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    showDialog: {
      handler(value) {
        if (!value) {
          this.facilityId = null;
          this.note = "";
        }
      },
    },
  },
  methods: {
    async add() {
      const facility = (await this.$api.company.findFacilityById(this.facilityId)).data;

      const reloadStops = this.tripStops.filter((s) => s.isReload);
      const newStop = {
        id: this.generateId(),
        type: OrderStopType.reload,
        status: OrderStopStatus.notStarted,
        isReload: true,
        editable: true,
        use: true,
        timeType: OrderStopTimeType.direct,
        timeTo: this.$dayjs().format("YYYY-MM-DD HH:mm:ss"),
        facility,
        facilityId: facility.id,
        timezone: facility.timezone,
        note: this.note,
        number: 0,
        reloadFreights: [],
        position: this.position,
      };

      const updatedReloads = [newStop, ...reloadStops]
        .sort((a, b) => a.position - b.position)
        .map((stop, idx) => ({ ...stop, number: idx + 1 }));

      newStop.number = updatedReloads.find((s) => s.id === newStop.id)?.number || newStop.number;

      this.$emit("add", newStop);
    },
    generateId() {
      const nanoid = customAlphabet("1234567890abcdef", 16);
      return nanoid();
    },
  },
};
</script>
<template>
  <omni-dialog
    v-model="showDialog"
    :disabled="!facilityId"
    primary-action-label="Add"
    title="Add reload stop"
    width="585"
    @primary-action:click="add"
  >
    <div class="py-4">
      <facility-select v-model="facilityId" class="mb-3" editable />
    </div>
  </omni-dialog>
</template>
